<template>
  <div
    class="solfigrf-player solfigrplyr"
    :class="[{ gw_loading: loading }, { gw_placeholder: blurred }]"
  >
    <div
      class="solfigrplyr_ra_table gw_loading_text"
      style="--loading_text-radius: 2px"
    >
      <div
        v-for="gg in item.groupRange"
        :key="gg.id"
        class="solfigrplyr_ra_table_rtc"
        :style="`--opacity-range: ${gg.range};`"
      ></div>
    </div>
    <div class="solfigrplyr_left gw_loading_text gw_placeholder_text">
      <GwMenu
        v-if="hasEditableName"
        ref="gwmenu"
        :isInside="false"
        class="mr-auto"
      >
        <template #opener="{ value }">
          <div class="d-flex position-relative">
            <div
              class="solfigrplyr_name gw_btn gw_btn_small mr-auto"
              style="justify-content: flex-start; --padding: 0 0 0 0.25rem"
            >
              <div v-html="getPlayerHtmlPosition(item.display_position)"></div>
              <div
                class="mdi mdi-menu-down clr-greys text-semi-large ml-1 transition_03"
                :class="{ rotated_180_before: value }"
                style="transition: 0.22s"
              />
            </div>
            <div
              v-if="item.display_position !== item.position"
              class="clr-grey text-medium weight_500"
              style="margin: auto 0 0 0.75rem"
              v-html="item.position"
            ></div>
          </div>
        </template>
        <template #default="{ methods }">
          <GwBtns
            data-gwmenu="noclose"
            :options="[...displayPositions, item.position]"
            :value="item.display_position"
            class="gwbtns_vertical_white gw_menu"
            @click="
              (_e, val) => {
                methods.toggleOpen(false)
                $emit('update:player', { ...item, display_position: val })
              }
            "
          >
            <template #default="{ item: val }">
              <span v-html="getPlayerHtmlPosition(val)"></span>
            </template>
          </GwBtns>
        </template>
      </GwMenu>
      <div
        v-else
        class="d-flex position-relative"
      >
        <div
          class="mdi mr-1"
          :class="item.position === 'OOP' ? 'mdi-account' : 'mdi-account-outline'"
        ></div>
        <div
          class="solfigrplyr_name my-auto"
          v-html="getPlayerHtmlPosition(item.display_position)"
        ></div>

        <div
          v-if="item.display_position !== item.position"
          class="clr-grey text-small weight_500 line-height_1"
          style="margin: auto 0 0.25rem 0.75rem"
          v-html="item.position"
        ></div>
      </div>
      <div
        class="solfigrplyr_combos"
        v-html="$t('solfigr.ranges.combos_xxx', { num: numFixedUnit(item.combos, 'combos') })"
      ></div>
      <div
        class="solfigrplyr_percentage"
        v-html="
          `${numFixed(
            item.percentage * 100,
            item.percentage < 0.00001
              ? 6
              : item.percentage < 0.0001
                ? 5
                : item.percentage < 0.001
                  ? 4
                  : 2,
          )}%`
        "
      ></div>
    </div>
    <GwBtn
      v-if="canRemove"
      style="position: absolute; right: 0.25rem; top: 0.25rem"
      variant="btn_text_grey_white"
      icon="mdi-close"
      @click="e => removePlayer(e)"
    ></GwBtn>
  </div>
</template>

<script>
import GwBtn from '@/components/lib/GwBtn/GwBtn.vue'
import GwBtns from '@/components/lib/GwBtns'
import GwMenu from '@/components/lib/GwMenu'
import { getLegalPositions } from '@/helpers/constants'

import float_mix from '@/mixins/float_mix'
import format_mix from '@/mixins/format_mix'

export default {
  name: 'SolfigrPlayers',
  components: {
    GwBtns,
    GwMenu,
    GwBtn,
  },
  mixins: [float_mix, format_mix],
  props: {
    item: {
      default: () => ({
        position: '',
        display_position: '',
        combos: 0,
        percentage: 0,
        groupRange: [],
      }),
    },
    hasEditableName: Boolean,
    groups: { default: () => [] },
    loading: Boolean,
    blurred: Boolean,
    canRemove: { default: false },
  },
  emits: ['update:player', 'remove:player'],
  data() {
    this.displayPositions = getLegalPositions()
  },
  methods: {
    removePlayer(e) {
      e.stopPropagation()
      this.$emit('remove:player')
    },
  },
}
</script>

<style lang="scss" scoped>
.solfigrplyr {
  min-height: 0;
  min-width: 15rem;
  display: flex;
  gap: 0.5rem;

  background: var(--clr-black-1-3);
  --clr-rtc: var(--clr-range-default);
  --table-radius: 2px;
  --clr-percentage: var(--clr-grey-2);
  --clr-combos: var(--clr-grey-2);
  --ra-table-size: 4.125rem;
  padding: 0.5rem;
  cursor: pointer;
  gap: 1rem;
  border-radius: 4px;
  &_error {
    --clr-percentage: var(--clr-error);
    --clr-combos: var(--clr-error);
  }
  &_left {
    display: flex;
    flex-direction: column;
    min-width: 7rem;
  }
  &_name {
    font-size: 1rem;
    font-weight: 500;
  }
  &_combos {
    color: var(--clr-combos);
    font-size: 0.875rem;
  }
  &_percentage {
    color: var(--clr-percentage);
    font-size: 0.875rem;
  }

  &_ra_table {
    height: var(--ra-table-size);
    width: var(--ra-table-size);
    display: grid;
    flex-shrink: 0;
    grid-template-columns: repeat(13, 1fr);
    grid-template-rows: repeat(13, 1fr);
    border-radius: var(--table-radius);
    overflow: hidden;
    background: var(--clr-black-0);
    &_rtc {
      background: var(--clr-rtc);
      opacity: var(--opacity-range);
      transition: 0.1s;
    }
  }
}
</style>
